import HeaderGeneric from "../../../../../components/generic/headerGeneric";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import themeBase from "../../../../../utils/theme/themeBase";
import { CommandBar, DatePicker, IComboBox, ICommandBarItemProps, Label, PrimaryButton } from "@fluentui/react";
import TokenService from "../../../../../services/tokenService";
import { useCallback, useEffect, useRef, useState } from "react";
import { urlTelerik } from "../../../../../services/http-common";
import AuthService from "../../../../../services/authService";
import { keyAccess } from "../../../../../utils/helpers/helpers";
import { ETelerikViewmode } from "../../../../../components/generic/baseTelerik";
import { onFormatDate } from "../../../../../utils/helpers/dateHelpers";
import { ComboBoxIDS } from "../../../../../components/generic/ComboBoxIDS";
import personaServicio from "../../../../../services/persona/personaServicio";
import ListaVerificacionService from "../../../../../services/listaVerificacionService";
import IPERCService from "../../../../../services/IPERCService";
import { BaseReportesTelerik } from "../../../../../components/generic/baseReportesTelerik";
import { BaseTelerikV1 } from "../../../../../components/generic/baseTelerikV1";
import IconHelper from "../../../../../utils/helpers/iconHelper";
import reporteServicio from "../../../../../services/reporteService";
import { IExportarReporte, IParametro } from "../../../../../Interfaces/base/IBase";

let title: string = "Reporte General de Iperc";
let subTitle: string = "Reporte General de Iperc";
let subTitle2: string = "";
let reportName = "IPERCReporteHistorico.trdx";

export interface IComboBoxOptionPersonalizado {
  key: string;
  text: string;
  puesto?: string;
}
export interface IReporteGeneralIperc {
  FechaInicio: Date | null;
  FechaFin: Date | null;
  SupervisorId: string | null;
  EstadoId: string | null;
}

export const ReporteGeneralIperc = () => {
  const urlTelerikR = `${urlTelerik}/reports`;
  // const viewerRef = useRef();
  let viewerRef;
  let t = TokenService.getToken();
  // const viewerRef = useRef();
  let viewMode = ETelerikViewmode.INTERACTIVE;
  const comboBoxRefSupervisores = useRef<IComboBox>(null);
  const comboBoxRefEstado = useRef<IComboBox>(null);

  const [search, setSearch] = useState("");
  const [searchEstado, setSearchEstado] = useState("");

  const controllerRef = useRef<AbortController>(new AbortController());
  const [SupervisoresCombo, setSupervisoresCombo] = useState<
    IComboBoxOptionPersonalizado[]
  >([]);
  const [estados, setEstados] = useState<IComboBoxOptionPersonalizado[]>([]);

  const [filtro, setfiltro] = useState<IReporteGeneralIperc>({
    FechaInicio: new Date(),
    FechaFin: new Date(),
    SupervisorId: null,
    EstadoId: null
  });

  // useEffect(() => {
  //   var { viewerObject } =
  //     viewerRef.current != null ? viewerRef.current : viewerObject;
  //   viewerObject.authenticationToken(TokenService.getToken());
  //   viewerObject.reportSource({
  //     report: "IPERCReporteHistorico.trdx",
  //     parameters: filtro,
  //   });
  // }, [filtro]);

  const transformarParametros = (parametros: IReporteGeneralIperc): IParametro[] => {
    return Object.entries(parametros).map(([key, value]) => ({
      Key: key,
      Value: value,
    }));
  };

  function descargarReporte(extension: string) {
    const reporteExportar: IExportarReporte = {
      report: reportName,
      Extension: extension
    }
    if (filtro !== undefined) {
      if (filtro !== null) {
        console.log("----Parametros-----")
        console.log(filtro)
        //reporteExportar.Parametros=parametros;
        reporteExportar.Parametros = transformarParametros(filtro);
      }
    }
    reporteServicio.exportaReporte(reporteExportar)
      .then((response) => {
        if (response.status === 200) {
          const dataUrl = response.data;

          // Create a link element
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

          // Simulate a click on the link to trigger the download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }
        else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // useEffect(() => {
  //   fetch(`${urlTelerikR}/version`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${TokenService.getToken()}`,
  //     },
  //   })

  // Función para recargar el componente
  const recargarComponente = () => {
    setfiltro({
      ...filtro,
      FechaInicio: new Date(),
      FechaFin: new Date(),
      SupervisorId: null,
      EstadoId: null
    });
    setKey(prevKey => prevKey + 1);
  };

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      // onClick: (arg) => actualizarTabla(),
      // onClick: () => viewerRef.refreshReport(),
      onClick: recargarComponente,
    }
  ];


  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        descargarReporte("PDF");
      },
    },
    {
      ...IconHelper.ICON_EXCEL,
      onClick: () => {
        descargarReporte("XLSX");
      },
    }
  ];


  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        setfiltro({ ...filtro, FechaInicio: date });
        setKey(prevKey => prevKey + 1);
        // setFilter({ ...filter, fechaInicio: _formatDate(date, ",") });
        break;
      case "fin":
        // setfiltro({ ...filtro, FechaFin: _formatDate(date, ",") });
        setfiltro({ ...filtro, FechaFin: date });
        setKey(prevKey => prevKey + 1);

        break;
      default:
        break;
    }
  };

  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        // case "actividad":
        //   filtro({ ...filtro, actividadId: o.key });
        //   break;
        // case "equipo":
        //   setFilter({ ...filter, equipoId: o.key });
        //   break;
        case "supervisor":
          //console.log("Super-Select", o.key)
          if (o?.key) {
            setfiltro({ ...filtro, SupervisorId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        case "estado":
          if (o?.key) {
            setfiltro({ ...filtro, EstadoId: o.key });
            setKey(prevKey => prevKey + 1);
          }
          break;
        // case "guardia":
        //   setFilter({ ...filter, guardia: o.key });
        //   break;
        default:
          break;
      }
    }
  };

  const _onkeyUpSearchSupervisores = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefSupervisores.current?.focus(false);
      setSearch("");
    } else {
      _openOptionSupervisores();
      let { value } = event?.target as HTMLInputElement;
      setSearch(value);
    }
  };

  const _onkeyUpSearchEstados = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefEstado.current?.focus(false);
      setSearchEstado("");
    } else {
      _openOptionEstados();
      let { value } = event?.target as HTMLInputElement;
      setSearchEstado(value);
    }
  };
  const _openOptionSupervisores = useCallback(
    () => comboBoxRefSupervisores.current?.focus(true),
    []
  );

  const _openOptionEstados = useCallback(
    () => comboBoxRefEstado.current?.focus(true),
    []
  );
  const onClickComboSupevisores = () =>
    comboBoxRefSupervisores.current?.focus(true);

  const onClickComboEstados = () => comboBoxRefEstado.current?.focus(true);

  const getComboSupervisores = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;

    personaServicio
      .getSupervisoresCombo(search, newController)
      .then((res) => {
        if (res.status === 200) {
          setSupervisoresCombo(res.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const obtenerPuesto = (key: any) => {
    const puestos = SupervisoresCombo?.find((elem) => elem.key === key);
    return puestos ? puestos.puesto : "No Tiene Puesto";
  };
  useEffect(() => {
    getComboSupervisores();
  }, [search]);

  useEffect(() => {
    getComboSupervisores();
  }, [search]);

  const dataEstados = (search: string = "") => {
    IPERCService.comboEstados(search)
      .then((res) => {
        const data = res.data.data.map((x) => ({
          key: x.id,
          text: x.nombre,
        }));

        setEstados(data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };
  useEffect(() => {
    dataEstados();
  }, []);


  const [key, setKey] = useState(0);

  // useEffect(() => {
  //   setKey(prevKey => prevKey + 1);
  // }, [filtro])

  useEffect(() => {
    const hideExportButton = () => {
      const exportButton: any = document.querySelector("#trv-main-menu-export-command");
      //console.log(exportButton)

      if (exportButton) {
        // console.log(exportButton)
        exportButton.remove();
        // exportButton.style.display = 'none';
        clearInterval(interval);
      }
    };

    // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
    const interval = setInterval(hideExportButton, 1);

    // Limpia el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, [key, reportName]);

  // useEffect(() => {

  // }, [filtro])

  return (
    <>
      <div
        className="ms-Grid-col ms-sm12 ms-md4 ms-lg4"
        style={{
          paddingTop: "0.5em",
        }}
      >
        <HeaderGeneric
          title={title}
          subTitle={subTitle}
          subTitle2={subTitle2}
          enabledicon={true}
        // sizeTitles={{ first: 24, second: 11, third: 10 }}
        />
      </div>
      <br />
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            width: "25%",
          }}
        >
          <div
            style={{
              margin: "0 10px",
              padding: "0 10px",
              width: "100%",
              border: "solid 1px #d5d5d5",
            }}
          >
            <Label
              style={{
                display: "flex",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              Filtros
            </Label>
            {/* <pre>{JSON.stringify(filtro, null, 2)}</pre> */}
            <DatePicker
              label="Fecha Inicio:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={filtro.FechaInicio!}
              onSelectDate={(date?: any) => {
                _onSelectDate(date, "inicio");
              }}
              formatDate={onFormatDate}
            //   maxDate={new Date()}
            />
            <DatePicker
              label="Fecha Fin:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={filtro.FechaFin!}
              onSelectDate={(date?: any) => {
                _onSelectDate(date, "fin");
              }}
              formatDate={onFormatDate}
            //   maxDate={new Date()}
            />

            <ComboBoxIDS
              title="Supervisor:"
              componentRef={comboBoxRefSupervisores}
              selectedKey={filtro.SupervisorId}
              KeyUp={_onkeyUpSearchSupervisores}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "supervisor");
              }}
              onClick={onClickComboSupevisores}
              useComboBoxAsMenuWidth={false}
              dropdownWidth={380}
              options={SupervisoresCombo}
              onRenderOption={(option) => (
                <>
                  {option && (
                    <div>
                      <span>{option?.text}</span>
                      <br />
                      <span
                        style={{
                          paddingBottom: "0.9px",
                          color: "#777",
                          fontSize: "0.7rem",
                        }}
                      >
                        {obtenerPuesto(option?.key)}
                      </span>
                    </div>
                  )}
                </>
              )}
            />

            <ComboBoxIDS
              title="Estado:"
              componentRef={comboBoxRefEstado}
              selectedKey={filtro.EstadoId}
              KeyUp={_onkeyUpSearchEstados}
              onChange={(e, o) => {
                onChangeComboBox(e, o, "estado");
              }}
              onClick={onClickComboEstados}
              options={estados}
            />
          </div>
        </div>
        {/* <TelerikReportViewer
          ref={viewerRef}
          serviceUrl={urlTelerikR}
          reportSource={{
            report: "IPERCReporteHistorico.trdx",
            parameters: { ...filtro },
            // parameters: { editors: { multiSelect: { parametros } } },
          }}
          viewerContainerStyle={themeBase.telerikStyle}
          parametersAreaVisible={true}
          viewMode={viewMode}
          scaleMode="FIT_PAGE_WIDTH"
          scale={1.0}
          enableAccessibility={false}
        /> */}

        <div className="ms-Grid-col ms-sm12 ms-lg12">
          {/* <BaseTelerikV1
            reportName={reportName}
            parametros={filtro}
            formatos={2}
          /> */}
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <CommandBar
              items={_items}
              farItems={_farItems}
              styles={themeBase.commadStyles}
            />
          </div>
          <div key={key}>
            <TelerikReportViewer
              ref={el => viewerRef = el}
              serviceUrl={urlTelerikR}
              reportSource={{
                report: reportName,
                parameters: { ...filtro },
                // parameters: { editors: { multiSelect: { parametros } } },
              }}
              viewerContainerStyle={themeBase.telerikStyle}
              parametersAreaVisible={true}
              viewMode={viewMode}
              scaleMode="FIT_PAGE_WIDTH"
              scale={1.0}
              enableAccessibility={false}

              // viewerContainerStyle={viewerOptions.viewerContainerStyle}


              authenticationToken={t}
            //toolbarItems={viewerOptions.toolbar.items}
            //skipBlankPages={false}
            />
          </div>
        </div>

      </div>
    </>
  );
};
